module.exports = __webpack_public_path__ + "img/informatiepunt-digitale-overheid.svg";